/**
 * The pens for the drawing game, as colour data rather than styling: a canvas cannot read a CSS token,
 * and every player must see the same sketch, so these are fixed values. Index 8 is the eraser (paper).
 * Kept in lib/ for the same reason tag-colors.ts is: the colour here is the content.
 */
export const INK = [
  'rgb(15 23 42)',
  'rgb(220 38 38)',
  'rgb(234 88 12)',
  'rgb(202 138 4)',
  'rgb(22 163 74)',
  'rgb(37 99 235)',
  'rgb(147 51 234)',
  'rgb(120 72 36)',
  'rgb(255 255 255)',
] as const
export const PAPER = 'rgb(255 255 255)'
